import { getChatbotResponse } from 'backend/chatbotcs'; // 确保这些是你的后端.jsw文件中定义的函数
import { sendChatMessage } from 'backend/wix-chat';

$w.onReady(function () {
    let messages = [];

    const logMessage = (role, content) => {
        const message = {
            role,
            content,
        };
        messages.push(message);
    };

    $w("#wixChat1").onMessageSent(async (message) => {
        const channelId = message.channelId;
        const messageText = message.payload.text; // 用户发送的消息文本

        console.log(message);

        logMessage("user", messageText);
        const answer = await getChatbotResponse(messages);
        logMessage(answer.role, answer.content);
        sendChatMessage(answer.content, channelId);

        console.log(message);
    });
});
 